import { isRouteErrorResponse, useRouteError } from 'react-router';

/**
 * Renders whatever went wrong below the shell.
 *
 * The message is shown only outside production. A router error can carry a
 * server response, and one of those has already been seen to include more than
 * anyone meant to publish - so the default is to say nothing specific.
 */
export function RouteError() {
  const error = useRouteError();

  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Unknown error';

  return (
    <section role="alert">
      <h1>Something went wrong</h1>
      <p>The page could not be displayed. Reloading may help.</p>
      {import.meta.env.DEV ? <pre>{detail}</pre> : null}
    </section>
  );
}
